// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1Ttxo","left":"InfoRow_left__--tTo"};